<div class="row">
  <div class="card shadow-none rounded">
    <div class="card-body">
      <div class="col-12 col-md-12 col-xxl-12 col-xl-12">
        <div class="row">
          <div class="col-12 col-xxl-10 col-xl-10 col-md-10 col-lg-10 col-sm-10">
            <h4 class="fw-bold">
              Creditors - {{commonService.headerName}}
            </h4>
          </div>
          <div class="col-12 col-xxl-2 col-xl-2 col-md-2 col-lg-2 col-sm-2 text-start text-sm-end p-sm-0 pt-2">
            <button type="button" class="btn btn-outline-themecolorlight" style="padding: 7px;font-weight: 600; font-size: 14px;" tabindex="-1" (click)="TotalBack()">Close Accounts</button>
          </div>
        </div>
      </div>
      <hr />
      <div class="col-12 col-md-12 col-xxl-12 col-xl-12 col-lg-12  col-sm-12">
        <div class="row">
          <div class="col-12">
            <h5 class="fw-bolder font-size-16">
              Creditors - within one year
            </h5>
            <p class="text-dark">Please enter notes on creditors - amounts falling due within one year.</p>
            <p class="text-dark">If you do not have any notes to make, please return to the notes menu and de-select this section.</p>
          </div>
        </div>
        <form [formGroup]="credformoneyear" (ngSubmit)="save()">
          <div class="row ps-3">
            <div class="col-12 col-xxl-11 col-xl-12 col-md-12 col-lg-12 col-sm-12">
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <div class="row">
                      <div class="col-xxl-4 col-xl-4 col-md-12 col-lg-12 col-sm-12 col-12">
                        <div class="pt-2 mb-4">
                          <!--<h6 class="fw-bolder font-size-16">Indicates required field  <span class="text-danger">*</span></h6>-->
                        </div>
                      </div>
                      <div class="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="row">
                          <div [ngClass]="commonService.showControl? 'col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6':'col-xxl-9 col-xl-10 col-lg-10 col-md-11 col-sm-12 col-12'">
                            <div class="mb-2 text-center">
                              <h6 class="mb-0 fw-bolder">{{commonService.StartYear}}</h6>
                              <label>({{commonService.CAPeriodFrom}} to {{commonService.CAPeriodTo}})</label>
                            </div>
                          </div>
                          <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6" *ngIf="commonService.showControl==true">
                            <div class="mb-2 text-center">
                              <h6 class="mb-0 fw-bolder">{{commonService.LastYear}}</h6>
                              <label>({{commonService.StartdateLastAP}} to {{commonService.LYAccountingPeriod}})</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 ps-0 ps-lg-5">
                  <div class="form-group">
                    <div class="row">
                      <div class="col-xxl-4 col-xl-4 col-md-12 col-lg-12 col-sm-12 col-12">
                        <div class="pt-2 mb-4">
                          <label class="m-t-5 font-weight-600">Bank loans and overdrafts</label>
                        </div>
                      </div>
                      <div class="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="row">
                          <div [ngClass]="commonService.showControl? 'col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6':'col-xxl-9 col-xl-10 col-lg-10 col-md-11 col-sm-12 col-12'">
                            <div class="input-group mb-3">
                              <div class="input-group-text">
                                <span class=" theme-color font-weight-600">£</span>
                              </div>
                              <input type="text" class="form-control AccountNumber text-end" [appTooltip]="showBubbledata" appNumberdirective formControlName="BankBorrowingsOverdrafts" maxlength="11" (blur)="calculationsforOneYear()" />
                            </div>
                          </div>
                          <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6" *ngIf="commonService.showControl==true">
                            <div class="input-group mb-3">
                              <div class="input-group-text">
                                <span class=" theme-color font-weight-600">£</span>
                              </div>
                              <input type="text" class="form-control AccountNumber text-end" [appTooltip]="showBubbledata" appNumberdirective (blur)="lastyearcalculations()" formControlName="BankBorrowingsOverdrafts_LY" maxlength="11" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="row">
                      <div class="col-xxl-4 col-xl-4 col-md-12 col-lg-12 col-sm-12 col-12">
                        <div class="pt-2 mb-4">
                          <label class="m-t-5 font-weight-600">
                            Amounts due under finance leases and
                            hire purchase contracts
                          </label>
                        </div>
                      </div>
                      <div class="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="row">
                          <div [ngClass]="commonService.showControl? 'col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6':'col-xxl-9 col-xl-10 col-lg-10 col-md-11 col-sm-12 col-12'">
                            <div class="input-group mb-3">
                              <div class="input-group-text">
                                <span class=" theme-color font-weight-600">£</span>
                              </div>
                              <input type="text" class="form-control AccountNumber text-end" [appTooltip]="showBubbledata" appNumberdirective formControlName="FinanceLeaseLiabilitiesPresentValueTotal" maxlength="11" (blur)="calculationsforOneYear()" />
                            </div>
                          </div>
                          <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6" *ngIf="commonService.showControl==true">
                            <div class="input-group mb-3">
                              <div class="input-group-text">
                                <span class=" theme-color font-weight-600">£</span>
                              </div>
                              <input type="text" class="form-control AccountNumber text-end" [appTooltip]="showBubbledata" appNumberdirective (blur)="lastyearcalculations()" formControlName="FinanceLeaseLiabilitiesPresentValueTotal_LY" maxlength="11" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="row">
                      <div class="col-xxl-4 col-xl-4 col-md-12 col-lg-12 col-sm-12 col-12">
                        <div class="pt-2 mb-4">
                          <label class="m-t-5 font-weight-600">
                            Trade creditors
                          </label>
                        </div>
                      </div>
                      <div class="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="row">
                          <div [ngClass]="commonService.showControl? 'col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6':'col-xxl-9 col-xl-10 col-lg-10 col-md-11 col-sm-12 col-12'">
                            <div class="input-group mb-3">
                              <div class="input-group-text">
                                <span class=" theme-color font-weight-600">£</span>
                              </div>
                              <input type="text" class="form-control AccountNumber text-end" [appTooltip]="showBubbledata" appNumberdirective formControlName="AndicaTradeCreditorsTradePayables" maxlength="11" (blur)="calculationsforOneYear()" />
                            </div>
                          </div>
                          <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6" *ngIf="commonService.showControl==true">
                            <div class="input-group mb-3">
                              <div class="input-group-text">
                                <span class=" theme-color font-weight-600">£</span>
                              </div>
                              <input type="text" class="form-control AccountNumber text-end" [appTooltip]="showBubbledata" appNumberdirective (blur)="lastyearcalculations()" formControlName="AndicaTradeCreditorsTradePayables_LY" maxlength="11" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="row">
                      <div class="col-xxl-4 col-xl-4 col-md-12 col-lg-12 col-sm-12 col-12">
                        <div class="pt-2 mb-4">
                          <label class="m-t-5 font-weight-600">
                            Taxation and social security
                          </label>
                        </div>
                      </div>
                      <div class="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="row">
                          <div [ngClass]="commonService.showControl? 'col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6':'col-xxl-9 col-xl-10 col-lg-10 col-md-11 col-sm-12 col-12'">
                            <div class="input-group mb-3">
                              <div class="input-group-text">
                                <span class=" theme-color font-weight-600">£</span>
                              </div>
                              <input type="text" class="form-control AccountNumber text-end" [appTooltip]="showBubbledata" appNumberdirective formControlName="OtherTaxationSocialSecurityPayable" maxlength="11" (blur)="calculationsforOneYear()" />
                            </div>
                          </div>
                          <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6" *ngIf="commonService.showControl==true">
                            <div class="input-group mb-3">
                              <div class="input-group-text">
                                <span class=" theme-color font-weight-600">£</span>
                              </div>
                              <input type="text" class="form-control AccountNumber text-end" [appTooltip]="showBubbledata" appNumberdirective (blur)="lastyearcalculations()" formControlName="OtherTaxationSocialSecurityPayable_LY" maxlength="11" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="row">
                      <div class="col-xxl-4 col-xl-4 col-md-12 col-lg-12 col-sm-12 col-12">
                        <div class="pt-2 mb-4">
                          <label class="m-t-5 font-weight-600">
                            Accruals and deferred income
                          </label>
                        </div>
                      </div>
                      <div class="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="row">
                          <div [ngClass]="commonService.showControl? 'col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6':'col-xxl-9 col-xl-10 col-lg-10 col-md-11 col-sm-12 col-12'">
                            <div class="input-group mb-3">
                              <div class="input-group-text">
                                <span class=" theme-color font-weight-600">£</span>
                              </div>
                              <input type="text" class="form-control AccountNumber text-end" [appTooltip]="showBubbledata" appNumberdirective formControlName="AccruedLiabilitiesDeferredIncome" maxlength="11" (blur)="calculationsforOneYear()" />
                            </div>
                          </div>
                          <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6" *ngIf="commonService.showControl==true">
                            <div class="input-group mb-3">
                              <div class="input-group-text">
                                <span class=" theme-color font-weight-600">£</span>
                              </div>
                              <input type="text" class="form-control AccountNumber text-end" [appTooltip]="showBubbledata" appNumberdirective (blur)="lastyearcalculations()" formControlName="AccruedLiabilitiesDeferredIncome_LY" maxlength="11" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="row">
                      <div class="col-xxl-4 col-xl-4 col-md-12 col-lg-12 col-sm-12 col-12">
                        <div class="pt-2 mb-4">
                          <label class="m-t-5 font-weight-600">
                            Other creditors
                          </label>
                        </div>
                      </div>
                      <div class="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="row">
                          <div [ngClass]="commonService.showControl? 'col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6':'col-xxl-9 col-xl-10 col-lg-10 col-md-11 col-sm-12 col-12'">
                            <div class="input-group mb-3">
                              <div class="input-group-text">
                                <span class=" theme-color font-weight-600">£</span>
                              </div>
                              <input type="text" class="form-control AccountNumber text-end" [appTooltip]="showBubbledata" appNumberdirective formControlName="OtherCreditors" maxlength="11" (blur)="calculationsforOneYear()" />
                            </div>
                          </div>
                          <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6" *ngIf="commonService.showControl==true">
                            <div class="input-group mb-3">
                              <div class="input-group-text">
                                <span class=" theme-color font-weight-600">£</span>
                              </div>
                              <input type="text" class="form-control AccountNumber text-end" [appTooltip]="showBubbledata" appNumberdirective (blur)="lastyearcalculations()" formControlName="OtherCreditors_LY" maxlength="11" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="row">
                      <div class="col-xxl-4 col-xl-4 col-md-12 col-lg-12 col-sm-12 col-12">
                        <div class="pt-2 mb-4">
                          <label class="m-t-5 font-weight-600"> Total </label>
                        </div>
                      </div>
                      <div class="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="row">
                          <div [ngClass]="commonService.showControl? 'col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6':'col-xxl-9 col-xl-10 col-lg-10 col-md-11 col-sm-12 col-12'">
                            <div class="input-group mb-3">
                              <div class="input-group-text">
                                <span class=" theme-color font-weight-600">£</span>
                              </div>
                              <input type="text" class="form-control AccountNumber text-end" [appTooltip]="showBubbledata" formControlName="CreditorsDueWithinOneYear" maxlength="11" (blur)="calculationsforOneYear()" />
                            </div>
                          </div>
                          <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6" *ngIf="commonService.showControl==true">
                            <div class="input-group mb-3">
                              <div class="input-group-text">
                                <span class=" theme-color font-weight-600">£</span>
                              </div>
                              <input type="text" class="form-control AccountNumber text-end" [appTooltip]="showBubbledata" formControlName="CreditorsDueWithinOneYear_LY" maxlength="11" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-xxl-11 col-xl-12 col-md-12 col-lg-12 col-sm-12 mt-3">
              <label>
                If you have provided security for debts, please enter any additional text about security for debts in the field below.
              </label>
              <div class="mb-3">
                <textarea class="form-control allowSpecialChars" rows="6" [appTooltip]="showBubbledata" appNumberdirective required formControlName="DescriptionMaterialOperatingLeasingArrangements" maxlength="4000"></textarea>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="col-12 col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 text-end mt-4">
        <button type="button" class="btn btn-outline-back p-1 ps-3 pe-3 me-2" (click)="back()">Back</button>
        <button type="button" class="btn themedefault p-1 ps-3 pe-3 ms-1 me-0" (click)="save()">Next</button>
      </div>
    </div>
  </div>
</div>
